import { render, staticRenderFns } from "./ColegioInactivo.vue?vue&type=template&id=1d494d7e&"
import script from "./ColegioInactivo.vue?vue&type=script&lang=js&"
export * from "./ColegioInactivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports